import { Overlay, OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, HostListener, Injector, Input, OnDestroy, ViewContainerRef } from '@angular/core';
import { SeImageTooltipComponent, TOOLTIP_DATA } from './se-image-tooltip.component';

@Directive({
    selector: '[seImageTooltip]',
})
export class SeImageTooltipDirective implements OnDestroy {
    @Input() seImageTooltip!: string;

    private overlayRef: OverlayRef | null = null;

    constructor(
        private element: ElementRef<HTMLElement>,
        private overlay: Overlay,
        private viewContainer: ViewContainerRef,
    ) {}

    @HostListener('mouseenter')
    @HostListener('focus')
    showTooltip(): void {
        if (this.overlayRef?.hasAttached() === true) {
            return;
        }

        this.attachTooltip();
    }

    @HostListener('mouseleave')
    @HostListener('blur')
    hideTooltip(): void {
        if (this.overlayRef?.hasAttached() === true) {
            this.overlayRef?.detach();
        }
    }

    ngOnDestroy(): void {
        this.overlayRef?.dispose();
    }

    private attachTooltip(): void {
        if (this.overlayRef === null) {
            const positionStrategy = this.getPositionStrategy();
            this.overlayRef = this.overlay.create({ positionStrategy });
        }

        const injector = Injector.create({
            providers: [
                {
                    provide: TOOLTIP_DATA,
                    useValue: this.seImageTooltip,
                },
            ],
        });
        const component = new ComponentPortal(SeImageTooltipComponent, this.viewContainer, injector);
        this.overlayRef.attach(component);
    }

    private getPositionStrategy(): PositionStrategy {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.element)
            .withPositions([
                {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'top',
                }
            ]);
    }
}
